import {
  TABLE_SEARCH_PARAMS_UPDATE,
  TABLE_SEARCH_PARAMS_CLEAR,
  TABLE_DATA_GET_REQUEST,
  TABLE_DATA_GET_SUCCESS,
  TABLE_DATA_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { queryStringBuilder } from '../../../utils/helpers';
import { getTableSearchParams } from '../../../reducers/uiElements';

function updateTableSearchParams(reduxIdentifier, params, initialSearchParams) {
  return {
    type: TABLE_SEARCH_PARAMS_UPDATE,
    reduxIdentifier,
    initialSearchParams,
    params,
  };
}

function clearTableSearchParams(reduxIdentifier, initialSearchParams) {
  return {
    type: TABLE_SEARCH_PARAMS_CLEAR,
    initialSearchParams,
    reduxIdentifier,
  };
}

function getTableSearchResults(endpoint, reduxIdentifier, responseObjectName, method = HTTP_METHOD.GET) {
  return {
    types: [TABLE_DATA_GET_REQUEST, TABLE_DATA_GET_SUCCESS, TABLE_DATA_GET_FAILURE],
    buildCallParameters: state => ({
      method,
      path: `v1/query/${endpoint +
        (method === HTTP_METHOD.GET ? queryStringBuilder(getTableSearchParams(reduxIdentifier)(state)) : '')}`,
      data: method === HTTP_METHOD.POST ? getTableSearchParams(reduxIdentifier)(state) : null,
    }),
    reduxIdentifier,
    responseObjectName,
  };
}

export { updateTableSearchParams, clearTableSearchParams, getTableSearchResults };
